import React, { Dispatch, SetStateAction } from 'react';

export const getPrimaryColor = () => {
  return '#000000';
};

export const getSecondaryColor = () => {
  return '#767894';
};

export const getBrandColor = () => {
  return '#6CF96A';
};

export const getNovoIconColor = () => {
  return '#2E3192';
};

export const getSecondaryInitialColor = () => {
  return '#f56875';
};

export const getLightBackgroundColor = () => {
  return 'rgba(166, 168, 221, 0.15)';
};

export const getBrand = () => {
  return 'novo';
};

export const shouldDisplayMotionModal = () => {
  return window.location.origin.includes('novo');
};

export const getPhoneNumber = () => {
  const brand = getBrand();

  return brand === 'motion' ? '844-425-0049' : '888-606-0328';
};

export const shouldCoBrand = () => {
  const isPartner = false;
  const isCoBrandedPage =
    window.location.pathname.includes('review-policy') ||
    window.location.pathname.includes('payment') ||
    window.location.pathname.includes('welcome');

  return isPartner && isCoBrandedPage;
};

interface Context {
  brand: string;
  setBrand: Dispatch<SetStateAction<string>>;
  primaryColor?: string;
  setPrimaryColor?: Dispatch<SetStateAction<string>>;
  primaryHoverColor?: string;
  setPrimaryHoverColor?: Dispatch<SetStateAction<string>>;
  primaryDisabledColor?: string;
  setPrimaryDisabledColor?: Dispatch<SetStateAction<string>>;
  secondaryColor?: string;
  setSecondaryColor?: Dispatch<SetStateAction<string>>;
  secondaryInitialColor?: string;
  setSecondaryInitialColor?: Dispatch<SetStateAction<string>>;
  lightBackground?: string;
  setLightBackgroundColor?: Dispatch<SetStateAction<string>>;
  coBrand?: boolean;
  setCoBrand?: Dispatch<SetStateAction<boolean>>;
}
export const BrandContext = React.createContext({} as Context);

export const BrandProvider = BrandContext.Provider;
